<template>
    <Slide :title="title" :subtitle="subtitle">
        <div class="cr:md:mx-[7rem]">
            <p class="cr:text-center cr:font-bold cr:pb-2">{{ budget }}/Day</p>
            <InputRange :max="max" :min="min" :step="1" max-suffix="+" v-model="budget"></InputRange>
        </div>
    </Slide>
</template>

<script setup lang="ts">

import {ref, computed} from "vue";
import Slide from "@/components/slides/Slide.vue";
import InputRange from "@/components/elements/InputRange.vue";

const min = 1;
const max = 100;
const budget = ref(5);

const props = defineProps({
    title: {
        type: String,
        default: 'How many leads do you need per day?'
    },
    subtitle: {
        type: String,
        default: 'We personalize lead plans to match your volume.'
    }
});

const slidePayload = computed(() => {
    return {
        daily_leads: budget.value,
    }
});
const validate = () => true;
const canContinue = computed(() => true);

defineExpose({
    canContinue,
    slidePayload,
    validate
});

</script>